import { useState, useEffect } from 'react';
import useApi from "./useApi";


const useVendorOrderDetails = (orderId) => {
    const {get} = useApi();
    const {data, isLoading, error} = get(`/vendor/orders/${orderId}`);

    return {
        order: data?.data || null,
        isLoading,
        error,
    };
}

export default useVendorOrderDetails;
